import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import Navbar from "../../Layouts/Navbar";
import Footer from "../../Layouts/Footer";
import LeftSideBar from "../../Layouts/LeftSideBar";
import { toast } from "react-toastify";
import { authHeaders,getSessionToken } from "../utils/session";

const ManagePage = () => {
  const [listPageData, setListPageData] = useState();
  const [token, setToken] = useState(getSessionToken());

  useEffect(() => {
    setToken(getSessionToken());
    loadContent();
  }, []);

  const loadContent = async () => {
    const response = await axios.get(`${API_BASE_URL}/get-page`, {
      headers: {
        ...authHeaders(),
        "content-type": "multipart/form-data",
      },
    });

    // console.log(response.data.pages);
    if (response.data.status == 200) {
      setListPageData(response.data.pages.reverse());
    }
  };

  const handleDelete = (id) => {
    const result = window.confirm("Do you want to delete ?");
    const data = {
      id: id,
    };
    if (result) {
      axios
        .post(`${API_BASE_URL}/delete-page`, data, {
          headers: {
            ...authHeaders(),
          },
        })
        .then((response) => {
          if (response.data.status === 200) {
            toast.success("Page delete successfully");
            axios
              .get(`${API_BASE_URL}/get-page`, {
                headers: {
                  ...authHeaders(),
                },
              })
              .then((response) => {
                setListPageData(response.data.pages.reverse());
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
    }
  };

  const handleActive = async (status, id) => {
    let updatedStatus = status == 0 ? 1 : 0;

    const res = await axios.post(
      `${API_BASE_URL}/update-page-status`,
      { status: updatedStatus, id: id },
      {
        headers: {
          ...authHeaders(),
        },
      }
    );
    const response = JSON.parse(JSON.stringify(res));
    // console.log(response);
    if (response.data.status === 200) {
      loadContent();
      if (status == 1) {
        toast.success("Inactive successfully");
      } else {
        toast.success("Active successfully");
      }
    }
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage Pages </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">Manage Pages</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-end">
              <div className="col-lg-12 mb-2 ">
                <Link
                  to={"/cms/managepage/addpage"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add a page
                </Link>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">
                      Page List ({listPageData?.length})
                    </h4>
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            {/* <th styles="width: 20px;">
                              <div className="form-check font-size-16 align-middle">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="transactionCheck01"
                                />
                                <label
                                  className="form-check-label"
                                  for="transactionCheck01"
                                ></label>
                              </div>
                            </th> */}
                            <th className="align-middle">Page ID</th>
                            <th className="align-middle">Page Name</th>
                            <th className="align-middle">Page Slug</th>
                            <th className="align-middle">Parent Link</th>
                            <th className="align-middle">Header/Footer</th>
                            <th className="align-middle">Status</th>
                            <th className="align-middle">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listPageData?.map((item) => (
                            <>
                              <tr>
                                {/* <td>
                                  <div className="form-check font-size-16">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="transactionCheck02"
                                    />
                                    <label
                                      className="form-check-label"
                                      for="transactionCheck02"
                                    ></label>
                                  </div>
                                </td> */}
                                <td>
                                  <a
                                    href="javascript: void(0);"
                                    className="text-body fw-bold"
                                  >
                                    {item.id}
                                  </a>
                                </td>
                                <td>{item.page_name}</td>
                                <td>{item.page_slug}</td>
                                <td>{item.parent_page}</td>
                                <td>{item.parent_page}</td>
                                <td>
                                  {item.status == 1 ? (
                                    <span className="badge badge-pill badge-soft-success font-size-11">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge badge-pill badge-soft-danger font-size-11">
                                      Inactive
                                    </span>
                                  )}
                                </td>

                                <td>
                                  <Link
                                    to={`/cms/managepage/editpage/${item.id}`}
                                    type="button"
                                    className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                  >
                                    <i className="fa fa-pen"></i>
                                  </Link>
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm btn-rounded waves-effect waves-light ms-2"
                                    onClick={() => {
                                      handleDelete(item.id);
                                    }}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm btn-rounded  ms-2"
                                    onClick={() => {
                                      handleActive(item.status, item.id);
                                    }}
                                  >
                                    <i className="fa fa-ban"></i>
                                  </button>
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagePage;
